import React from "react";

function CTAStatus({
  isActive,
  setIsActive,
}) {

  return (
    <div className="mb-4">

      <label className="form-label fw-semibold">
        CTA Status
      </label>


      <div className="status-box">

        <div className="d-flex align-items-center">

          <span
            className={
              isActive
                ? "status-dot active"
                : "status-dot inactive"
            }
          >
          </span>

          <span>
            {isActive ? "Active" : "Inactive"}
          </span>

        </div>


        <div className="form-check form-switch">

          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            aria-label="CTA is active"
            checked={isActive}
            onChange={() => setIsActive(!isActive)}
          />

        </div>

      </div>

      <div className="form-text">
        Active CTAs can be displayed to visitors.
      </div>

    </div>
  );
}

export default CTAStatus;